import apiClient from './client'

export type ActivityPeriod = '24h' | '7d' | '30d'

export interface ActivityCategoryBreakdown {
  category: string
  seconds: number
  pct: number
}

export interface ActivitySummary {
  period: string
  total_seconds: number
  categories: ActivityCategoryBreakdown[]
  afk_ratio: number
  in_call_seconds: number
  coverage_pct: number
}

export interface ActivityTimelinePoint {
  t: string
  durations: Record<string, number>
}

export interface ActivityTimeline {
  resolution: 'minute' | 'hour'
  points: ActivityTimelinePoint[]
}

export interface FocusCorrelationWindow {
  window_start: string
  window_end: string
  voip_focus_pct: number
  browser_other_pct: number
  afk_pct: number
  in_call: boolean
  verdict: string
}

export async function getActivitySummary(
  machineId: string,
  period: ActivityPeriod = '24h'
): Promise<ActivitySummary> {
  const response = await apiClient.get<ActivitySummary>(`/activity/${machineId}/summary`, {
    params: { period },
  })
  return response.data
}

export async function getActivityTimeline(
  machineId: string,
  start: string,
  end: string,
  resolution: 'minute' | 'hour' = 'hour'
): Promise<ActivityTimeline> {
  const response = await apiClient.get<ActivityTimeline>(`/activity/${machineId}/timeline`, {
    params: { start, end, resolution },
  })
  return response.data
}

export async function getFocusCorrelation(
  machineId: string,
  days = 7
): Promise<{ windows: FocusCorrelationWindow[] }> {
  const response = await apiClient.get<{ windows: FocusCorrelationWindow[] }>(
    `/activity/${machineId}/focus-correlation`,
    { params: { days } }
  )
  return response.data
}
